__turbopack_context__.v({
  "below-container": "order-details-scroll-bar-module-scss-module__dCoXMq__below-container",
  "container": "order-details-scroll-bar-module-scss-module__dCoXMq__container",
  "continue-button": "order-details-scroll-bar-module-scss-module__dCoXMq__continue-button",
  "price": "order-details-scroll-bar-module-scss-module__dCoXMq__price",
  "price-continue": "order-details-scroll-bar-module-scss-module__dCoXMq__price-continue",
});
